module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/81dc21a52d314d1c74b6f74ddc4e8e41.png";